import { Action, createReducer, on } from '@ngrx/store';
import * as CopyAssetWizardActionsV26 from './actions';
import { State, initialState } from './state';

export const copyAssetWizardFeatureKey = 'copyAssetWizardV26';

const addProductWizardReducer = createReducer(
  initialState,

  on(CopyAssetWizardActionsV26.selectInitStep, (state, { initStep }) => ({
    ...state,
    initStep,
    dueDatesStep: { activationDate: null, deactivationDate: null },
  })),
  on(CopyAssetWizardActionsV26.selectAssetServicesInit, (state, { initAssetServiceStep }) => ({
    ...state,
    initAssetServiceStep,
  })),
  on(CopyAssetWizardActionsV26.selectDueDatesStep, (state, { dueDatesStep }) => ({
    ...state,
    dueDatesStep,
  })),
  on(CopyAssetWizardActionsV26.selectDeskStep, (state, { deskStep }) => ({
    ...state,
    deskStep,
  })),
  on(CopyAssetWizardActionsV26.selectServiceStep, (state, { serviceStep }) => ({
    ...state,
    serviceStep,
  })),
  on(CopyAssetWizardActionsV26.deleteServiceStep, (state) => ({
    ...state,
    serviceStep: null,
  })),
  on(CopyAssetWizardActionsV26.selectAdditionalStep, (state, { addInfoStep }) => ({
    ...state,
    addInfoStep,
  })),
  on(CopyAssetWizardActionsV26.deleteAdditionalStep, (state) => ({
    ...state,
    addInfoStep: null,
  })),
  on(CopyAssetWizardActionsV26.exitCopyAssetWizard, (state) => ({
    ...state,
    initStep: null,
    initAssetServiceStep: null,
    dueDatesStep: null,
    deskStep: null,
    serviceStep: null,
    addInfoStep: null,
    errorMessage: null,
  })),
  on(CopyAssetWizardActionsV26.destroyWizard, (state) => ({
    ...state,
    initStep: null,
    initAssetServiceStep: null,
    dueDatesStep: null,
    deskStep: null,
    serviceStep: null,
    addInfoStep: null,
    errorMessage: null,
  })),
  on(CopyAssetWizardActionsV26.createNewCopyAsset, (state, { newOrder }) => ({
    ...state,
    newOrder,
  })),
  on(CopyAssetWizardActionsV26.createNewOrderSuccess, (state, { response }) => ({
    ...state,
    newOrderResponse: response,
  })),
  on(CopyAssetWizardActionsV26.createNewOrderFail, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return addProductWizardReducer(state, action);
}
